import styled from '@emotion/styled';
import setMargin from './../../helpers/set-margin';

export const TextBtn = styled.button`
  ${setMargin};
  text-decoration: underline;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
`;

export const ExampleWrapper = styled.div`
  ${setMargin};
`;
